import "./TheTrainingPath.module.css";
import MainNavigation from "@/reusable_sections/Header";
import YourTransformationRoadmap from "./sections/YourTransformationRoadmap";
import FuelYourBody from "./sections/FuelYourBody";
import CommonQuestions from "./sections/CommonQuestions";
import FooterEssentials from "@/reusable_sections/Footer";
export default function TheTrainingPathPage() {
  return <div>
      <MainNavigation />
      <YourTransformationRoadmap />
      <FuelYourBody />
      <CommonQuestions />
      <FooterEssentials />
    </div>;
}